@if (safeSvg) {
<span
  class="gatewee-bank-svg-logo gw-inline-flex gw-max-h-full gw-max-w-full gw-items-center gw-justify-center [&_svg]:gw-block [&_svg]:gw-max-h-full [&_svg]:gw-max-w-full [&_svg]:gw-shrink-0"
  [innerHTML]="safeSvg"
></span>
} @else {
<ng-content></ng-content>
}
